import Animated from '@/features/ui/animated'
import { FC } from 'react'
import { AnimatedProps } from 'react-native-reanimated'
import { Path, SvgProps } from 'react-native-svg'

type Props = Omit<AnimatedProps<SvgProps>, 'fill'> & { fill?: string }

const PhoneIcon: FC<Props> = ({ fill, ...props }) => {
    return (
        <Animated.Svg viewBox="0 0 38 38" width={24} height={24} {...props}>
            <Path
                d="M1.32422 9.27742C1.32422 23.9166 13.1916 35.784 27.8308 35.784H31.8068C34.0027 35.784 35.7828 34.0039 35.7828 31.808V29.3842C35.7828 28.472 35.162 27.6768 34.277 27.4556L26.4607 25.5015C25.6848 25.3075 24.8681 25.5975 24.3882 26.2374L22.6737 28.5233C22.1761 29.1868 21.3155 29.4802 20.5368 29.1949C14.6931 27.0542 10.054 22.4152 7.91334 16.5714C7.62809 15.7927 7.92146 14.9321 8.58491 14.4345L10.8709 12.7201C11.5108 12.2402 11.8007 11.4235 11.6067 10.6475L9.65266 2.83127C9.43141 1.94628 8.63625 1.32544 7.72402 1.32544H5.30021C3.10433 1.32544 1.32422 3.10555 1.32422 5.30143V9.27742Z"
                stroke={fill || 'currentColor'}
                strokeWidth={2.65066}
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </Animated.Svg>
    )
}

export default PhoneIcon
